export default {
    namespaced: true,
    actions: {
        initDebug({ dispatch, rootGetters }) {
            window.DEBUG = {
                permissions: {
                    get all() {
                        return JSON.parse(JSON.stringify(rootGetters['permissions/permissions']));
                    },
                    set(permissions) {
                        dispatch('permissions/setPermissions', permissions, {root: true});
                    },
                    isAllowed(permissionToCheck) {
                        return rootGetters['permissions/isAllowed'](permissionToCheck)
                    }
                }
            }
        }
    }
}
